<template>
  <el-dialog
    :visible="visible"
    width="65%"
    @close="cancel"
    destroy-on-close
    title="订单日志"
    custom-class="customModal">
    <div class="table">
      <OrderLog v-if="visible" :orderId="this.order_id" />
    </div>
  </el-dialog>
</template>

<script>
  import OrderLog from '../orderLog/orderLog.vue';
  export default {
    name: 'orderLogModal',
    components: { OrderLog },
    data() {
      return {
        visible: false,
        order_id: '',
      }
    },
    methods: {
      open(order_id) {
        this.order_id = order_id;
        this.visible = true;
      },
      cancel() {
        this.visible = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
.table {
  height: 600px;
  position: relative;
}
</style>